
export class UploadStatusHandler {
    private _progress: number = 0;
    private _currentTrial: number = 0;
    private _isInProgress: boolean = true;
    readonly allowedTrials: number = 2;


    reset(): void {
        this._progress = 0;
        this._currentTrial = 0;
        this._isInProgress = true;
    }

    public get progress(): number {
        return this._progress;
    }
    public set progress(progress: number) {

        this._isInProgress = (progress > this._progress) ;
        this._progress = progress;
    }

    public set isInProgress(isInProgress: boolean) {
        this._isInProgress = isInProgress;
    }

    public get currentTrial(): number {
        return this._currentTrial;
    }

    public nextTrial(): void {

        this._currentTrial += 1;
    }

    public get isInProgress(): boolean {
        return (this._isInProgress);
    }

    public trialsReached(): boolean {
        return (this._currentTrial == this.allowedTrials);
    }
}


// WEBPACK FOOTER //
// ./js/utils/UploadStatusHandler.ts